'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  // Standard flows with only 2 steps
  crm: 'crm',
  fbCrm: 'fb-crm',
  marketing: 'marketing',
  sales: 'sales',
  academy: 'academy',
  classroomTraining: 'classroom-training',
  content: 'content',
  hubspotForStartups: 'hubspot-for-startups',
  integrations: 'integrations',
  purchase: 'purchase',
  service: 'service',
  trial: 'trial',
  trialSignup: 'trial-signup',
  // Wordpress flows
  wordpress: 'wordpress',
  wordpressLogin: 'wordpress-login',
  // Hubless flow
  growthHub: 'growth-hub',
  // Special flow available only from checkout
  checkout: 'checkout',
  developers: 'developers',
  standaloneCmsDeveloper: 'standalone-cms-developer',
  // Academy
  embedded: 'embedded',
  embeddedCrm: 'embedded-crm',
  embeddedSales: 'embedded-sales',
  embeddedMarketing: 'embedded-marketing',
  embeddedService: 'embedded-service',
  // Partner flow
  standaloneCmsPartner: 'standalone-cms-partner',
  // Custom flows
  directoryListing: 'directory-listing',
  salesPartner: 'sales-partner',
  // Verified flows
  serviceVerified: 'service-verified',
  partnerClient: 'partner-client'
};
module.exports = exports['default'];